import { supabase } from '@/lib/supabase'

/**
 * Vérifie et configure le bucket de stockage Supabase pour les avatars
 */
export async function ensureStorageBucketExists(): Promise<boolean> {
    try {
        // Vérifier si le bucket 'avatars' existe
        const { data: buckets, error: listError } = await supabase.storage.listBuckets()

        if (listError) {
            // Erreur silencieuse si pas de permissions pour lister les buckets
            // On assume que le bucket existe
            return true
        }

        const avatarsBucket = buckets.find(bucket => bucket.name === 'avatars')

        if (avatarsBucket) {
            return true
        }

        // Le bucket n'existe pas - assume quand même qu'il existe (peut être un problème de permissions)
        return true

    } catch (error) {
        // En cas d'erreur, on assume que le bucket existe
        return true
    }
}

/**
 * Vérifie les permissions RLS pour le bucket avatars
 */
export async function checkStoragePermissions(): Promise<void> {
    // Désactivé - le bucket avatars n'accepte que les images
    // Les permissions seront vérifiées lors du premier upload réel
    return
}

/**
 * Configuration complète du storage au démarrage de l'app
 */
export async function initializeStorage(): Promise<void> {
    // console.log('🔄 Initializing storage...')

    const bucketExists = await ensureStorageBucketExists()

    if (bucketExists) {
        await checkStoragePermissions()
        // console.log('✅ Storage initialization complete')
    } else {
        // console.log('⚠️ Storage initialization incomplete - bucket missing')
    }
}

/**
 * Version simplifiée qui ne fait que vérifier l'existence
 */
export async function checkStorageAvailability(): Promise<boolean> {
    try {
        const { data: buckets } = await supabase.storage.listBuckets()
        const avatarsBucket = buckets?.find(bucket => bucket.name === 'avatars')
        return !!avatarsBucket
    } catch {
        return false
    }
}